import { getToken } from "../../../services/auth";
import * as React from 'react';
import styles from './Contratos.module.scss';
import { useRef, useState, useEffect, useContext } from 'react';
import { axiosBackend } from '../../../axios/Axios.js';
import dayjs, { Dayjs } from 'dayjs';
import Modal from "./components/Modal"
import editIcon from '../../../assets/edit.png';
import deleteIcon from '../../../assets/delete.png';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from 'notistack'

const Contracts_all = (props) => (
    <>
      {props.contracts[0] && props.contracts.map(contract => (
        <ContractItem deleteAct={props.deleteAct} client={props.client} editAct={props.editAct} logo_url={props.client.logo_url} p_key={contract.p_key} hours={contract.hours} bymonth={contract.bymonth} contract={contract}/>
      ))}
    </>
); 
  
function ContractItem(props) {
    const startdate = new Date(parseInt(props.contract.start) * 1000)
    const startstr = (String(startdate.getDate()).padStart(2, '0') + '/' + String(startdate.getMonth() + 1).padStart(2, '0') + '/' + startdate.getFullYear())

    const enddate = new Date(parseInt(props.contract.end) * 1000)
    const endstr = (String(enddate.getDate()).padStart(2, '0') + '/' + String(enddate.getMonth() + 1).padStart(2, '0') + '/' + enddate.getFullYear())

    return (
      <div className={styles.contract_item}>
        <div className={styles.contract_item_data}>
          <div className={styles.contract_item_image}>
            <div className={styles.contract_item_image_draw}>
            <img
              className={styles.contract_item_logo}
              src={props.logo_url}
              alt="alt text"
            />
            </div>
            <div className={styles.contract_item_client_name}>{props.contract.name}</div>
          </div>
          <div className={styles.contract_item_others_data}>
            <div className={styles.contract_item_others_data_info}>{props.contract.key ? props.contract.key : props.client.key}</div>
            <div className={styles.contract_item_others_data_info}>{startstr}</div>
            <div className={styles.contract_item_others_data_info}>{endstr}</div>
            <div className={styles.contract_item_others_data_info}>{props.contract.hours} horas{props.contract.bymonth ? "/mês" : " totais"}</div>
            <div className={styles.contract_item_others_data_info}><img className={styles.editIcon} src={editIcon} onClick={() => props.editAct(props.contract)}/><img className={styles.editIcon} src={deleteIcon} onClick={() => props.deleteAct(props.contract)}/></div>
          </div>
        </div>
        <hr className={styles.line} size={1} />
      </div>
    )
  }
  
export default function Contratos(props) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const CONTRACTS_URL = "/contracts"
    const [errMsg, setErrMsg] = useState('');
    const [loading, setLoading] = useState(true);
    const [contracts, setContracts] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);

    const [formData, setFormData] = useState({
      title: "Adicionar",
      button: "Adicionar",
      uuid: props.uuid,
      name: '',
      bymonth: true,
      start: dayjs(),
      end: dayjs(),
      hours: 0,
      sust: false,
      proj: false,
      key: props.client.key
    });

    const reloadContratcts = () => {
      axiosBackend.get(CONTRACTS_URL, config)
        .then(res => {
          setContracts(res.data);
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
        });
    }

    useEffect(() => {
      setLoading(true);
      axiosBackend.get(CONTRACTS_URL, config)
        .then(res => {
          setContracts(res.data);
          setLoading(false);
  
        })
        .catch(err => {
          setErrMsg(err.message);
          setLoading(false);
        });
    }, [props.uuid]);

    const editAct = (contract) => {
      setFormData({
        title: "Editar",
        button: "Salvar",
        uuid: props.uuid,
        c_uuid: contract.c_uuid,
        name: contract.name ? contract.name : "",
        bymonth: contract.bymonth,
        start: dayjs.unix(contract.start),
        end: dayjs.unix(contract.end),
        hours: contract.hours,
        sust: contract.sust,
        proj: contract.proj,
        key: contract.key ? contract.key : props.client.key
      });

      setModalOpen(true);
    }

    const deleteAct = async(contract) => {
       await axiosBackend.delete(CONTRACTS_URL, {
          params: {
            "uuid": props.uuid,
            "c_uuid": contract.c_uuid
          },
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getToken()}`
          },
        }).then( (response) => {
          reloadContratcts();
          enqueueSnackbar('Contrato removido com sucesso!', { 
            variant: 'success'
          });
        }).catch((error) => {
          enqueueSnackbar('Falha ao deletar contrato!', { 
            variant: 'error'
          });
        });
      } 

    const resetForm = () => {
      setFormData({
        title: "Adicionar",
        button: "Adicionar",
        uuid: props.uuid,
        name: '',
        bymonth: true,
        start: dayjs(),
        end: dayjs(),
        hours: 0,
        sust: false,
        proj: false,
        key: props.client.key
      });
    }

    const client = props.client

    const config = {
      params: {
        "uuid": props.uuid
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getToken()}`
      },
    }
    
    return(
      <div className={styles.component}>
        <Modal reloadContratcts={reloadContratcts} formData={formData} setFormData={setFormData} isOpen={isModalOpen} onClose={() =>{ resetForm(); setModalOpen(false)}} uuid={props.uuid} startDateObj={props.startDateObj}/>
        <div className={styles.button_div}>
          <button disabled={(contracts.length >= 4) || loading} onClick={() => setModalOpen(true)} className={styles.m_button}>+ Adicionar contrato</button>
        </div>
        <div className={styles.dados_box}>
        <div className={styles.contracts_main_column}>
          <div className={styles.contracts_title_column}>
            <div className={styles.contracts_title_row}>
              <div className={styles.contracts_title_name_box}>
                <p className={styles.contracts_title_name}>Nome do contrato</p>
              </div>
              <div className={styles.contracts_title_row_2}>
                <p className={styles.contracts_title_2}>Keyword</p>
                <p className={styles.contracts_title_2}>Data início</p>
                <p className={styles.contracts_title_2}>Data fim</p>
                <p className={styles.contracts_title_2}>Horas contratadas</p>
                <p className={styles.contracts_title_2}>Ações</p>
              </div>
            </div>
            <hr className={styles.line} size={1} />
          </div>
          <div className={styles.contracts_all}>
            <Contracts_all deleteAct={deleteAct} editAct={editAct} contracts={contracts} client={client}/>
          </div>
        </div>
        </div>
      </div>
    )
}